import { EngineConfigurationService } from 'AppServices/engineConfigurationService';
import AppConfig from 'Constants/AppConfig';
import { store } from 'Store/store'

export class FacebookHelper {
  constructor() {
    this.engineConfigurationService = new EngineConfigurationService();
  }

  facebookApiFunction(path) {
    return new Promise((resolve, reject) => {
      FB.api(path, (response) => resolve(response));
    });
  }

  async setUpFacebookLogin(loginState) {
    return new Promise(async (resolve, reject) => {
      let facebookAppId = await this.engineConfigurationService.getFacebookAppId();
      window.fbAsyncInit = () => {
        window.checkLoginState = loginState;
        FB.init({
          appId: `${facebookAppId}`,
          autoLogAppEvents: true,
          xfbml: true,
          version: `${AppConfig.facebookGraphApiVersion}`
        });
        FB.Event.subscribe('xfbml.render', () => {
          store.dispatch('setIsFbLoadCompleted', false)
          resolve();
        });
      }

      (function(d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) {
          window.fbAsyncInit();
          return;
        }
        js = d.createElement(s);
        js.id = id;
        js.src = 'https://connect.facebook.net/en_US/sdk.js';
        fjs.parentNode.insertBefore(js, fjs);
      })(document, 'script', 'facebook-jssdk');
    })
  }

  getFabookLoginStatus() {
    return new Promise((resolve, reject) => {
      FB.getLoginStatus((response) => {
        if (response.status === 'connected') {
          // used to return access token if available. else, return true.
          resolve((response.authResponse && response.authResponse.accessToken) || true);
        }
        else {
          resolve(false);
        }
      });
    })
  }

  logoutUser() {
    return new Promise((resolve, reject) => {
      FB.logout(() => {
        resolve(true);
      });
    })
  }

  loginUser(){
    FB.login();
  }
}